import styled, { css, FlattenSimpleInterpolation } from "styled-components";

import { CLOSED_CHAT_SIZE, OPEN_CHAT_SIZE } from "./constants";

export type ChatFrameState = "loading" | "closed" | "open";

const frameSize: Record<ChatFrameState, FlattenSimpleInterpolation> = {
  loading: css`
    width: 0;
    height: 0;
  `,
  closed: css`
    width: ${CLOSED_CHAT_SIZE.width}px;
    height: ${CLOSED_CHAT_SIZE.height}px;
  `,
  open: css`
    width: min(${OPEN_CHAT_SIZE.width}px, 100vw);
    height: min(${OPEN_CHAT_SIZE.height}px, 100vh);
  `,
};

export const ChatFrame = styled.iframe<{ $state: ChatFrameState }>`
  position: fixed;
  bottom: 0;
  right: 0;
  border: none;
  background: transparent;
  color-scheme: normal;
  z-index: 2147483647;
  ${({ $state }) => frameSize[$state]}
`;
